import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bb6c9fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item item-coop" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { style: {"margin-bottom":"5px"} }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "inner" }
const _hoisted_8 = { class: "avator" }
const _hoisted_9 = { class: "meta" }
const _hoisted_10 = { class: "meta-title" }
const _hoisted_11 = { style: {"margin-left":"5px"} }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = {
  key: 0,
  class: "desc"
}

import { ref, reactive, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useStoreData } from '@/hooks/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'ItemProjectCoop',
  props: {
  data: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

const props = __props
const store = useStore()
const definedBusinessItems = useStoreData([], () => {
  return store.state.base.businessItems
})
const definedIndustry = computed(() => {
  const val = definedBusinessItems.value
  return val.find(item => item.type == 'industry')?.items
})

const generateIndustry = str => {
  if (definedIndustry.value) {
    const item = definedIndustry.value.find(item => item.value == str)
    if (item) {
      return item.label
    }
  }
  return '未知'
}

const rate = ref(0)
const prjUrl = computed(() => {
  return '/coop/' + state.id
})
const state = reactive({ ...(props.data || {}) })
rate.value = Number(state.userStarLevel) || 0

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_rate = _resolveComponent("el-rate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: prjUrl.value,
      class: "poster"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: state.image || state.coverImage
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, [
          _createVNode(_component_router_link, { to: prjUrl.value }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(state.title), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_svg_icon, { icon: "icon_avator" }),
              _createElementVNode("span", null, _toDisplayString(state.userNickname), 1)
            ]),
            _createElementVNode("em", null, "分类：" + _toDisplayString(generateIndustry(state.industry)), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_rate, {
                modelValue: rate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rate).value = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(state.province) + _toDisplayString(state.city) + " " + _toDisplayString(state.area), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_12, " 截止:" + _toDisplayString((state.deadline ?? '').split(' ')[0]), 1)
            ])
          ])
        ]),
        (state.content)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(state.content), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})